import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

declare global {
  interface Window {
    RUM: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class RumService {
  getLocationHref(): string {
    return window.location.href;
  }

  isLocalhost(): boolean {
    return this.getLocationHref().includes('localhost');
  }

  initRUM() {
    if (!this.isLocalhost()) {
      if (window.RUM && window.RUM.RumInit) {
        window.RUM.RumInit({
          app: {
            name: environment.RUM_APP_ID,
            version: '1.0.0',
          },
          traceLog: true,
          useSendBeacon: true,
          interactions: true,
          console: true,
          apiKey: environment.RUM_API_KEY,
          instrumentations: {
            documentload: true,
            xhr: true,
            fetch: true,
          },
          metas: [
            () => ({
              page: {
                url: window.location.href,
                attributes: {
                  host: window.location.host,
                  path: window.location.pathname.replace(/(.+?)\/+$/, '$1'),
                  scRegion:
                    document.documentElement.getAttribute('data-region'),
                  language: document.documentElement.getAttribute('lang'),
                  expId:
                    document.documentElement.getAttribute('exp-id') ?? 'null',
                  expVariant:
                    document.documentElement.getAttribute('exp-variant') ??
                    'null',
                },
              },
            }),
          ],
        });
      }
    }
  }
}
